/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-03-22 13:46:36
 * @LastEditors: Li Yong
 * @LastEditTime: 2022-03-22 14:27:20
 */
import { tzRoleType, zsRoleType, drRoleType } from "@/utils/dataMap";
import { tzRouter } from "./tz";
import { zsRouter } from "./zs";
import { drRouter } from "./dr";
let localRouter = {};
localRouter[tzRoleType.id] = tzRouter;
localRouter[zsRoleType.id] = zsRouter;
localRouter[drRoleType.id] = drRouter;
export default localRouter;
